"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLayoutState = void 0;
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var SfilterPriceGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterPriceGroup");
var Pages_1 = require("@/rendering/common/Pages");
var MegaMenuTranslate_init_1 = require("@/pages/common/states/MegaMenuTranslate.init");
var MegaMenuState_init_1 = require("@/pages/common/states/MegaMenuState.init");
var MegaMenuSearchState_init_1 = require("@/pages/common/states/MegaMenuSearchState.init");
var MegafootState_init_1 = require("@/pages/common/states/MegafootState.init");
exports.defaultLayoutState = {
    remoteUrl: 'https://demo.okay.com',
    remoteUrlLocalized: 'https://demo.okay.com/en',
    careerUrl: 'https://devcareers.okay.com',
    googleApi: process.env.GOOGLEAPI,
    hidePrivacy: true,
    language: {
        current: LayoutState_1.Language.EN_US,
        languages: [
            {
                id: LayoutState_1.Language.EN_US,
                name: 'English',
                shortName: 'EN',
                code1: 'en',
                code2: 'en_US',
            },
            {
                id: LayoutState_1.Language.ZH_HK,
                name: '繁體中文',
                shortName: '繁',
                code1: 'zh-hk',
                code2: 'zh_HK',
            },
            {
                id: LayoutState_1.Language.ZH_CN,
                name: '簡體中文',
                shortName: '簡',
                code1: 'zh-cn',
                code2: 'zh_CN',
            },
        ],
    },
    saveCount: 0,
    nameLogin: 'Login',
    nameLogout: 'Logout',
    nameBack: 'Back',
    nameLanguage: 'Language',
    nameCurrency: 'Currency',
    nameReverifyEmail: 'Verify Email',
    nameNotVerified: 'Not Verified',
    isLoading: false,
    returnState: null,
    currencies: {
        currentCurrencyId: SfilterPriceGroup_1.SfilterCurrency.HKD,
        options: [
            {
                key: SfilterPriceGroup_1.SfilterCurrency.HKD,
                code2: 'HKD',
                code: 'HKD',
                symbol: 'HK$',
                ratio: 1,
            },
            {
                key: SfilterPriceGroup_1.SfilterCurrency.USD,
                code2: 'USD',
                code: 'USD',
                symbol: 'US$',
                ratio: 0.13,
            },
            {
                key: SfilterPriceGroup_1.SfilterCurrency.EUR,
                code2: 'EUR',
                code: 'EUR',
                symbol: '€',
                ratio: 0.11,
            },
            {
                key: SfilterPriceGroup_1.SfilterCurrency.RMB,
                code2: 'RMB',
                code: 'RMB',
                symbol: '¥',
                ratio: 0.87,
            },
            {
                key: SfilterPriceGroup_1.SfilterCurrency.GBP,
                code2: 'GBP',
                code: 'GBP',
                symbol: '£',
                ratio: 0.097,
            },
        ],
    },
    loginList: {
        name: '',
        children: [
            {
                name: 'Personal Details',
                link: '#',
            },
            {
                name: 'Change Password',
                link: '#',
                action: 'changePassword',
            },
            {
                name: 'Alerts',
                link: '#',
            },
            {
                name: 'My Places',
                link: '#',
            },
            {
                name: 'Logout',
                link: '#',
            },
        ],
    },
    unverifiedLoginList: {
        name: '',
        children: [
            {
                name: 'Resend Verification',
                link: '#',
            },
            {
                name: 'Logout',
                link: '#',
            },
        ],
    },
    saveslist: [
        {
            name: 'Saved Properties',
            link: '#',
        },
        {
            name: 'Saved Searches',
            link: '#',
        },
        {
            name: 'Recently Viewed',
            link: '#',
        }
    ],
    menulist: [
        {
            name: 'List Your Property',
            link: 'listproperty',
        },
        {
            name: 'Property Search',
            children: [
                {
                    name: 'For Rent (Hong Kong)',
                    link: 'property-search/rent',
                },
                {
                    name: 'For Sale (Hong Kong)',
                    link: 'property-search/buy',
                }
            ],
        },
        {
            name: 'Resources',
            page: Pages_1.Pages.RESOURCES,
            children: [
                {
                    name: 'News & Insight',
                    link: 'property-news',
                    page: Pages_1.Pages.NEWS_AND_INSIGHTS,
                },
                {
                    name: 'Ask an agent',
                    link: 'ask-an-agent',
                    page: Pages_1.Pages.ASK_AN_AGENT_LIST,
                },
                {
                    name: 'Guides',
                    link: 'property-guides',
                    page: Pages_1.Pages.GUIDES,
                },
                {
                    name: 'Mortgage',
                    link: 'monthlypayment',
                    page: Pages_1.Pages.MORTGAGE,
                },
            ],
        },
        {
            name: 'About Us',
            page: Pages_1.Pages.ABOUT,
            children: [
                {
                    name: 'Our Story',
                    link: 'about-us',
                    page: Pages_1.Pages.ABOUTUS,
                },
                {
                    name: 'Our Team',
                    children: [
                        {
                            name: 'Executive Team',
                            link: 'property-experts',
                            page: Pages_1.Pages.EXECUTIVE_LISTING,
                        },
                        {
                            name: 'Property Agent',
                            link: 'property-agent-team',
                            page: Pages_1.Pages.AGENT_LISTING,
                        },
                    ],
                },
                {
                    name: 'List your Property',
                    link: 'list-property',
                },
                {
                    name: 'Testimonials',
                    link: 'testimonials',
                },
                {
                    name: 'In the press',
                    link: 'in-the-press',
                    page: Pages_1.Pages.IN_THE_PRESS,
                },
                {
                    name: 'Inverstors',
                    link: 'inverstors',
                },
                {
                    name: 'Newsletters',
                    link: 'newsletters',
                },
                {
                    name: 'Contact Us',
                    link: 'enquiry.aspx',
                },
            ],
        },
        {
            name: 'Careers',
            link: '//careers.okay.com',
        },
    ],
    offices: [
        {
            logo: 'https://careers.okay.com/images/logos/okay_logo_dark.png',
            name: 'OKAY.COM Central Main Office',
            address: '15/F, Wilson House, 19-27 Wyndham Street, Central, Hong Kong',
            telephone: '2102 0888',
            googleMap: {
                lat: '22.280426',
                lng: '114.155803',
            },
        },
        {
            name: 'OKAY.COM Causeway Bay',
            address: '12/F Honest Building, 9-11 Leighton Road, Causeway Bay, Hong Kong',
            telephone: '2102 0888',
            googleMap: {
                lat: '22.276926',
                lng: '114.181462',
            },
        },
        {
            name: 'OKAY.COM Discovery Bay',
            address: 'Flat A, 7/F, Block 2, Neo Horizon Discovery Bay, Lantau Island New Territories',
            telephone: '2102 0829',
            googleMap: {
                lat: '22.307531',
                lng: '114.009799',
            },
        },
    ],
    activePanel: LayoutState_1.ActivePanel.NONE,
    callOrEmailActive: false,
    imgDomain: process.env.IMGURL,
    dialCodes: ['852', '853', '1', '86'],
    days: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
    months: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    years: [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014, 2013],
    tMegamenu: MegaMenuTranslate_init_1.defaultMegaMenuTranslate,
    megamenu: MegaMenuState_init_1.defaultMegaMenuState,
    megamenusearch: MegaMenuSearchState_init_1.defaultMegaMenuSearchState,
    megafoot: MegafootState_init_1.defaultMegafootState,
    lastSavedProperty: null,
};
